import React, { useContext, useEffect } from "react";
import { useState } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";

import { Modal, Row, Table } from "react-bootstrap";
import { CancelButton } from "../../common/Button";
import { variant_type } from "../../../utils/common";
library.add(fas);

const ProductModal = (props) => {
  const data = props?.data;

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Product Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table striped bordered hover responsive center>
            <thead>
              <tr className="">
                <th className="sr">Sr. No.</th>
                <th className="tax-name">Products </th>
                <th className="tax-name">Category </th>
                <th className="tax-name">Variant Name </th>
                {/* <th className="tax-name">Sub Category </th>
                <th className="tax-name">Child category</th> */}
                <th className="tax-name">Sub Total </th>
                {/* <th className="tax-name">Packing Charges </th> */}
                <th className="tax-name">Delivery Charges </th>
                {/* <th className="tax-name">Refer Discount</th>
                <th className="tax-name">Offer Discount </th> */}
                <th className="tax-name">Quantity </th>
                <th className="tax-name">Coupon Discount </th>
                <th className="tax-name">Total Tax </th>
                <th className="tax-name">Total Amount</th>
              </tr>
            </thead>
            <tbody>
              {data &&
                data.length > 0 &&
                data.map((item, index) => (
                  <tr key={item?.id || index}>
                    <td>{index + 1}</td>

                    <td>{item?.Product?.name || "-"}</td>

                    <td>{item?.Product?.p_category?.name || "-"}</td>

                    <td>
                      {item?.Product?.variant_type_id ===
                        variant_type.Single && (
                        <>
                          {item?.Product_Variant?.Metal?.name || "-"}{" "}
                          {item?.Product?.Unit?.name || ""}
                        </>
                      )}

                      {item?.Product?.variant_type_id ===
                        variant_type.Double && (
                        <>
                          <strong>Variant:</strong>{" "}
                          {item?.Double_Variant?.Product_Variant?.Metal?.name ||
                            "-"}
                          <br />
                          <strong>Size:</strong>{" "}
                          {item?.Double_Variant?.Size?.name || "-"}
                        </>
                      )}

                      {item?.Product?.variant_type_id ===
                        variant_type.Triple && (
                        <>
                          <strong>Variant:</strong>{" "}
                          {item?.Triple_Variant?.Double_Variant?.Product_Variant
                            ?.Metal?.name || "-"}
                          <br />
                          <strong>Size:</strong>{" "}
                          {item?.Triple_Variant?.Double_Variant?.Size?.name ||
                            "-"}
                          <br />
                          <strong>Diamond:</strong>{" "}
                          {item?.Triple_Variant?.Diamond?.name || "-"}
                        </>
                      )}
                    </td>
                    <td>
                      ₹{Number(item?.total_selling_price ?? 0).toFixed(2)}
                    </td>

                    <td>₹{Number(item?.delivery_charges ?? 0).toFixed(2)}</td>

                    <td>{item?.quantity ?? "-"}</td>

                    <td>₹{Number(item?.coupon_discount ?? 0).toFixed(2)}</td>

                    <td>₹{Number(item?.total_tax ?? 0).toFixed(2)}</td>

                    <td>₹{Number(item?.total_amount ?? 0).toFixed(2)}</td>
                  </tr>
                ))}
            </tbody>
          </Table>
          <Row className="mt-5 pb-3">
            <div className="d-flex justify-content-center">
              <Link>
                <CancelButton name={"Close"} handleClose={props.handleClose} />
              </Link>
            </div>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ProductModal;
